// https:/www.chartjs.org/docs/latest/samples/information.html

Chart.register(ChartDataLabels);

// Namespace vorbereiten //
window.sfs = window.sfs || {};
window.sfs.myCharts = window.sfs.myCharts || {};

// ========== 1. GLOBALS ========== //
window.sfs.chartFonts = {
  legend: { weight: "normal", size: 18, family: "UniversLTPro-45Light,Arial,sans-serif" },
  dataLabel: { weight: "normal", size: 18, family: "UniversLTPro-45Light,Arial Black,sans-serif" },
  axisTicks: { weight: "normal", size: 18, family: "UniversLTPro-45Light,Arial,sans-serif" }
};

window.sfs.chartColorsConfig = {
  black: "#000",
  lightGray: "#ccc",
  white: "#fff",
  red: "#eb3c24",
  redTransparent: "#eb3c2480"
};

// ========== 2. HELPER FUNCTIONS ========== //
function decodeBase64Utf8(str) {
  try {
    const binary = atob(str);
    const bytes = Uint8Array.from(binary, function(char) { return char.charCodeAt(0); });
    return new TextDecoder('utf-8').decode(bytes);
  } catch (e) {
    console.error("Fehler beim Dekodieren von Base64:", e);
    return null;
  }
}

function parseFlexibleLocalData(str) {
  if (!str) return { labels: [], datasets: [] };
  try {
    const parsed = JSON.parse(str);
    if (Array.isArray(parsed) && parsed[0] && parsed[0].length === 2) {
      return {
        labels: parsed.map(function(d) { return d[0]; }),
        datasets: [{ label: "Local", data: parsed.map(function(d) { return d[1]; }) }]
      };
    }
    if (parsed.labels && parsed.datasets) return parsed;
  } catch (e) {
    const arr = str.split(",").map(function(e) {
      const parts = e.split(":");
      if (parts.length < 2) return null;
      const label = parts[0];
      const val = parts.slice(1).join(":");
      const num = parseFloat(val);
      return !isNaN(num) ? [label.trim(), num] : null;
    }).filter(Boolean);

    if (arr.length) {
      return {
        labels: arr.map(function(d) { return d[0]; }),
        datasets: [{ label: "Local", data: arr.map(function(d) { return d[1]; }) }]
      };
    }
  }
  return { labels: [], datasets: [] };
}

function getCachedElement(id) {
  var el = window.sfs.cache.elements.get(id);
  if (!el || !document.contains(el)) {
    el = document.getElementById(id);
    if (el) window.sfs.cache.elements.set(id, el);
  }
  return el;
}

// ========== 3. CACHE ========== //
window.sfs.cache = {
  api: new Map(),
  elements: new Map(),
  CACHE_DURATION: 30000,
  set: function(cache, key, value, ttl) {
    if (ttl === undefined) ttl = 30000;
    cache.set(key, { data: value, expires: Date.now() + ttl });
  },
  get: function(cache, key) {
    var c = cache.get(key);
    if (!c || Date.now() > c.expires) {
      cache.delete(key);
      return null;
    }
    return c.data;
  },
  cleanup: function() {
    var now = Date.now();
    for (var entry of this.api.entries()) {
      var k = entry[0], v = entry[1];
      if (v.expires < now) this.api.delete(k);
    }
  }
};

setInterval(function() {
  window.sfs.cache.cleanup();
}, 300000);

// ========== 4. FETCH & DATENBESCHAFFUNG ========== //
window.sfs.fetchData = async function(endpoint, useDatasets, localDatasets, stacked) {
  if (useDatasets) return localDatasets;
  if (!endpoint && !stacked) return { labels: [], datasets: [] };

  var cached = window.sfs.cache.get(window.sfs.cache.api, endpoint);
  if (cached) return cached;

  if (!endpoint) return localDatasets;

  try {
    var res = await fetch("https://newsletter.sfs.biz/p/de.pinuts.sfs.api/" + endpoint);
    if (!res.ok) throw new Error("HTTP " + res.status);
    var data = await res.json();

    var valid = { labels: [], datasets: [] };

    if (Array.isArray(data) && data[0] && data[0].length === 2) {
      valid = {
        labels: data.map(function(d) { return d[0]; }),
        datasets: [{ label: endpoint, data: data.map(function(d) { return d[1]; }) }]
      };
    } else if (data.labels && data.datasets) {
      valid = data;
    }

    window.sfs.cache.set(window.sfs.cache.api, endpoint, valid);
    return valid;
  } catch (e) {
    console.error("Fetch error:", e);
    return { labels: [], datasets: [] };
  }
};

// ========== 5. LEGENDEN-ERSTELLUNG ========== //
window.sfs.createLegend = function(labels, colors, legendId) {
  var el = getCachedElement(legendId);
  if (!el || !Array.isArray(labels)) return;
  el.innerHTML = labels.map(function(label, i) {
    return (
      '<div class="legend-item">' +
      '<span class="legend-color" style="background-color:' + (colors[i] || window.sfs.chartColorsConfig.lightGray) + '"></span>' +
      '<span style="color:' + window.sfs.chartColorsConfig.black + '">' + String(label).replace(/[<>]/g, "") + '</span>' +
      '</div>'
    );
  }).join("");
};

// ========== 6. CHART ERSTELLUNG ========== //
... (der Rest des Codes wird hier im selben Format fortgeführt, vollständig!)